import React from 'react';

function Footer() {
    return (
        <div className="footer">
            <p>⭯ <a href="https://dev.azure.com/ExergyManagementLab/_git/Outlook2SageX">2.5.0</a> / Février 2025 - ✉ <a href="mailto:francois.brouchoud@hevs.ch">francois.brouchoud@hevs.ch</a></p>
        </div>
    );
}

export default Footer;
